module.exports = __webpack_public_path__ + "565fe3424c8dc2d779b824b8cf036859.svg";


//////////////////
// WEBPACK FOOTER
// ./images/trash-white.svg
// module id = 76
// module chunks = 0